/*
 * Package Import
 */
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/*
 * Local Import
 */
import Header from 'src/components/Admin/Header';
import PromotionTable from 'src/components/Admin/Pages/Promotion/PromotionTable';

// Helpers
import { trackEvent } from 'src/utils/tracking';
import { ADMIN_PROMOTIONS_TITLE } from 'src/constants/titles';

// Style
import * as S from './style';

/*
 * Code
 */
const PromotionPage = (): JSX.Element => {
  /*
   * Hooks
   */
  const { pathname } = useLocation();

  /**
   * LifeCycles
   */
  useEffect(() => {
    document.title = ADMIN_PROMOTIONS_TITLE;

    // Mixpanel tracking event
    trackEvent('Page Viewed', {
      title: ADMIN_PROMOTIONS_TITLE,
      url: pathname,
    });
  }, []);

  /**
   * Render
   */
  return (
    <S.Container>
      <Header pageTitle="Gestion des promotions" />
      <PromotionTable />
    </S.Container>
  );
};

/*
 * Export
 */
export default PromotionPage;
